// extracted by mini-css-extract-plugin
export default {"address":"Address_address__mKua0","holdForm":"Address_holdForm__pwrz9"};